import { forEach } from 'jszip';
import getSwiperSlider from '~/js/modules/slider';
import Accordion from '~/js/modules/accordion';

window.addEventListener(`DOMContentLoaded`, () => {

  const accordions = document.querySelectorAll(`.accordion`);

  if (accordions.length) {
    accordions.forEach((accordion) => {
      if (!accordion.classList.contains('main-nav__list')) {
        new Accordion(accordion)
      }
    });
  }

  /*Слайдер*/
  const newsSlider = document.querySelector('.news__slider');

  if (newsSlider) {
    let newsSwiper;

    const newsSwiperParams = {
      slidesPerView: 'auto',
      loop: false,
      autoplay: false,
      navigation: {
        nextEl: `.news .slider-arrows__arrow--next`,
        prevEl: `.news .slider-arrows__arrow--prev`,
        disabledClass: `disabled`,
      },
      pagination: false,
    };

    newsSwiper = getSwiperSlider(newsSlider, newsSwiperParams);

  }

  const close_btn = document.querySelectorAll('.js-close-btn')
  if (close_btn) {
    close_btn.forEach((el) => {
      el.addEventListener('click', () => {
        el.parentNode.remove()
      })
    })
  }
});
